
import { ALMContract } from './types';

export const sampleContracts: ALMContract[] = [
  // Vehicle Loans
  {
    id: "la001",
    name: "VL-001",
    reference: "LA-RAPL-2023-001",
    type: "Loan Asset",
    subtype: "Vehicle Loans",
    principalAmount: 500000000,  // ₹50 crore
    currentBalance: 450000000,   // ₹45 crore
    interestRate: 12.5,          // 12.5% p.a.
    interestType: "Fixed",
    sanctionDate: "2023-01-15",
    firstPaymentDate: "2023-02-15",
    maturityDate: "2026-01-15",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 13500000,       // ₹1.35 crore
      "month-3": 40500000,       // ₹4.05 crore
      "month-6": 81000000,       // ₹8.1 crore
      "month-12": 162000000,     // ₹16.2 crore
      "month-24": 324000000,     // ₹32.4 crore
      "day-1": 450000,          // ₹4.5 lakh
      "day-3": 1350000,         // ₹13.5 lakh
      "day-7": 3150000,         // ₹31.5 lakh
      "day-15": 6750000,        // ₹67.5 lakh
      "day-30": 13500000        // ₹1.35 crore
    },
    paymentSchedule: [
      { date: "2025-03-15", principal: 13850000, interest: 4687500 },
      { date: "2025-04-15", principal: 13975000, interest: 4558750 },
      { date: "2025-05-15", principal: 14100000, interest: 4429375 },
      { date: "2025-06-15", principal: 14225000, interest: 4299375 }
    ],
    prepaymentFeeStructure: "2% of outstanding principal",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 10000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "low",
    liquidityRisk: "low",
    creditRisk: "low",
    counterparty: {
      name: "Various Retail Customers",
      type: "Individual",
    }
  },
  {
    id: "la005",
    name: "VL-002",
    reference: "LA-HLP-2023-015",
    type: "Loan Asset",
    subtype: "Vehicle Loans",
    principalAmount: 800000000,  // ₹80 crore
    currentBalance: 780000000,   // ₹78 crore
    interestRate: 9.75,          // 9.75% p.a.
    interestType: "Floating",
    sanctionDate: "2023-08-15",
    firstPaymentDate: "2023-09-15",
    maturityDate: "2038-08-15",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 7100000,        // ₹71 lakh
      "month-3": 21300000,       // ₹2.13 crore
      "month-6": 42600000,       // ₹4.26 crore
      "month-12": 85200000,      // ₹8.52 crore
      "month-24": 170400000,     // ₹17.04 crore
      "day-1": 236667,          // ₹2.36 lakh
      "day-3": 710000,          // ₹7.1 lakh
      "day-7": 1656667,         // ₹16.56 lakh
      "day-15": 3550000,        // ₹35.5 lakh
      "day-30": 7100000         // ₹71 lakh
    },
    paymentSchedule: [
      { date: "2025-03-15", principal: 2500000, interest: 6337500 },
      { date: "2025-04-15", principal: 2500000, interest: 6317188 },
      { date: "2025-05-15", principal: 2500000, interest: 6296875 },
      { date: "2025-06-15", principal: 2500000, interest: 6276563 }
    ],
    prepaymentFeeStructure: "1% of prepaid amount",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 10000000,
    prepaymentLockInPeriod: "24 months",
    interestRateSensitivity: "high",
    liquidityRisk: "low",
    creditRisk: "low",
    counterparty: {
      name: "Various Home Buyers",
      type: "Individual"
    }
  },
  {
    id: "la008",
    name: "VL-003",
    reference: "LA-CAPL-2023-042",
    type: "Loan Asset",
    subtype: "Vehicle Loans",
    principalAmount: 350000000,  // ₹35 crore
    currentBalance: 315000000,   // ₹31.5 crore
    interestRate: 10.75,         // 10.75% p.a.
    interestType: "Fixed",
    sanctionDate: "2023-05-20",
    firstPaymentDate: "2023-06-20",
    maturityDate: "2026-05-20",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 9625000,        // ₹96.25 lakh
      "month-3": 28875000,       // ₹2.88 crore
      "month-6": 57750000,       // ₹5.77 crore
      "month-12": 115500000,     // ₹11.55 crore
      "month-24": 231000000,     // ₹23.1 crore
      "day-1": 320833,          // ₹3.2 lakh
      "day-3": 962500,          // ₹9.62 lakh
      "day-7": 2245833,         // ₹22.45 lakh
      "day-15": 4812500,        // ₹48.12 lakh
      "day-30": 9625000         // ₹96.25 lakh
    },
    paymentSchedule: [
      { date: "2025-03-20", principal: 9722222, interest: 2828125 },
      { date: "2025-04-20", principal: 9722222, interest: 2740538 },
      { date: "2025-05-20", principal: 9722222, interest: 2652951 },
      { date: "2025-06-20", principal: 9722222, interest: 2565363 }
    ],
    prepaymentFeeStructure: "1.5% of outstanding principal",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 5000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "low",
    liquidityRisk: "low",
    creditRisk: "low",
    counterparty: {
      name: "Various Fleet Owners",
      type: "Corporate"
    }
  },
  {
    id: "la009",
    name: "VL-004",
    reference: "LA-VEHL-2024-003",
    type: "Loan Asset",
    subtype: "Vehicle Loans",
    principalAmount: 180000000,  // ₹18 crore
    currentBalance: 180000000,   // ₹18 crore
    interestRate: 11.25,         // 11.25% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-01-10",
    firstPaymentDate: "2024-02-10",
    maturityDate: "2027-01-10",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 5250000,        // ₹52.5 lakh
      "month-3": 15750000,       // ₹1.57 crore
      "month-6": 31500000,       // ₹3.15 crore
      "month-12": 63000000,      // ₹6.3 crore
      "month-24": 126000000,     // ₹12.6 crore
      "day-1": 175000,          // ₹1.75 lakh
      "day-3": 525000,          // ₹5.25 lakh
      "day-7": 1225000,         // ₹12.25 lakh
      "day-15": 2625000,        // ₹26.25 lakh
      "day-30": 5250000         // ₹52.5 lakh
    },
    paymentSchedule: [
      { date: "2025-03-10", principal: 5000000, interest: 1687500 },
      { date: "2025-04-10", principal: 5000000, interest: 1640625 },
      { date: "2025-05-10", principal: 5000000, interest: 1593750 },
      { date: "2025-06-10", principal: 5000000, interest: 1546875 }
    ],
    prepaymentFeeStructure: "2% of outstanding principal",
    prepaymentMinimumNotice: "15 days",
    prepaymentMinimumAmount: 3000000,
    prepaymentLockInPeriod: "6 months",
    interestRateSensitivity: "medium",
    liquidityRisk: "low",
    creditRisk: "low",
    counterparty: {
      name: "Transport Services Ltd",
      type: "Corporate",
      rating: "A"
    }
  },
  {
    id: "la010",
    name: "VL-005",
    reference: "LA-VEHL-2024-017",
    type: "Loan Asset",
    subtype: "Vehicle Loans",
    principalAmount: 120000000,  // ₹12 crore
    currentBalance: 116000000,   // ₹11.6 crore
    interestRate: 10.5,          // 10.5% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-03-01",
    firstPaymentDate: "2024-04-01",
    maturityDate: "2027-03-01",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 3325000,        // ₹33.25 lakh
      "month-3": 9975000,        // ₹99.75 lakh
      "month-6": 19950000,       // ₹1.99 crore
      "month-12": 39900000,      // ₹3.99 crore
      "month-24": 79800000,      // ₹7.98 crore
      "day-1": 110833,          // ₹1.10 lakh
      "day-3": 332500,          // ₹3.32 lakh
      "day-7": 776167,          // ₹7.76 lakh
      "day-15": 1662500,        // ₹16.62 lakh
      "day-30": 3325000         // ₹33.25 lakh
    },
    paymentSchedule: [
      { date: "2025-03-01", principal: 3333333, interest: 1015000 },
      { date: "2025-04-01", principal: 3333333, interest: 986736 },
      { date: "2025-05-01", principal: 3333333, interest: 958472 },
      { date: "2025-06-01", principal: 3333333, interest: 930208 }
    ],
    prepaymentFeeStructure: "1.5% of outstanding principal",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 5000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "medium",
    liquidityRisk: "low",
    creditRisk: "low",
    counterparty: {
      name: "Premium Logistics Co",
      type: "Corporate",
      rating: "BBB+"
    }
  },
  
  // Personal Loans
  {
    id: "la004",
    name: "PL-001",
    reference: "LA-EDU-2024-003",
    type: "Loan Asset",
    subtype: "Personal Loans",
    principalAmount: 120000000,  // ₹12 crore
    currentBalance: 115000000,   // ₹11.5 crore
    interestRate: 10.25,         // 10.25% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-01-20",
    firstPaymentDate: "2024-07-20",
    maturityDate: "2029-01-20",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: false,
    cashflows: {
      "month-1": 981250,        // ₹9.81 lakh
      "month-3": 2943750,       // ₹29.43 lakh
      "month-6": 5887500,       // ₹58.87 lakh
      "month-12": 26450000,      // ₹2.64 crore
      "month-24": 52900000,      // ₹5.29 crore
      "day-1": 32708,          // ₹32.7k
      "day-3": 98125,          // ₹98.1k
      "day-7": 229167,         // ₹2.29 lakh
      "day-15": 490625,        // ₹4.90 lakh
      "day-30": 981250         // ₹9.81 lakh
    },
    paymentSchedule: [
      { date: "2025-07-20", principal: 1800000, interest: 982500 },
      { date: "2025-08-20", principal: 1800000, interest: 967125 },
      { date: "2025-09-20", principal: 1800000, interest: 951750 },
      { date: "2025-10-20", principal: 1800000, interest: 936375 }
    ],
    prepaymentFeeStructure: "No penalty after 1 year",
    prepaymentMinimumNotice: "7 days",
    prepaymentMinimumAmount: 1000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "low",
    liquidityRisk: "low",
    creditRisk: "low",
    counterparty: {
      name: "Various Students",
      type: "Individual"
    }
  },
  {
    id: "la006",
    name: "PL-002",
    reference: "LA-CORP-2023-022",
    type: "Loan Asset",
    subtype: "Personal Loans",
    principalAmount: 250000000,  // ₹25 crore
    currentBalance: 225000000,   // ₹22.5 crore
    interestRate: 13.25,         // 13.25% p.a.
    interestType: "Fixed",
    sanctionDate: "2023-04-10",
    firstPaymentDate: "2023-07-10",
    maturityDate: "2028-04-10",
    repaymentFrequency: "Quarterly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 2484375,       // ₹24.84 lakh
      "month-3": 16968750,       // ₹1.69 crore
      "month-6": 33937500,       // ₹3.39 crore
      "month-12": 67875000,      // ₹6.78 crore
      "month-24": 135750000,     // ₹13.57 crore
      "day-1": 82812,          // ₹82.8k
      "day-3": 248437,         // ₹2.48 lakh
      "day-7": 579688,         // ₹5.79 lakh
      "day-15": 1242187,       // ₹12.42 lakh
      "day-30": 2484375        // ₹24.84 lakh
    },
    paymentSchedule: [
      { date: "2025-04-10", principal: 12500000, interest: 7453125 },
      { date: "2025-07-10", principal: 12500000, interest: 7043750 },
      { date: "2025-10-10", principal: 12500000, interest: 6634375 },
      { date: "2026-01-10", principal: 12500000, interest: 6225000 }
    ],
    prepaymentFeeStructure: "2% of outstanding principal",
    prepaymentMinimumNotice: "45 days",
    prepaymentMinimumAmount: 50000000,
    prepaymentLockInPeriod: "18 months",
    interestRateSensitivity: "medium",
    liquidityRisk: "medium",
    creditRisk: "low",
    counterparty: {
      name: "Sundar Chemicals Pvt Ltd",
      type: "Corporate",
      rating: "AA-"
    }
  },
  {
    id: "la011",
    name: "PL-003",
    reference: "LA-PERS-2023-089",
    type: "Loan Asset",
    subtype: "Personal Loans",
    principalAmount: 85000000,   // ₹8.5 crore
    currentBalance: 76500000,    // ₹7.65 crore
    interestRate: 15.75,         // 15.75% p.a.
    interestType: "Fixed",
    sanctionDate: "2023-07-15",
    firstPaymentDate: "2023-08-15",
    maturityDate: "2026-07-15",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 2817187,        // ₹28.17 lakh
      "month-3": 8451561,        // ₹84.51 lakh
      "month-6": 16903122,       // ₹1.69 crore
      "month-12": 33806244,      // ₹3.38 crore
      "month-24": 67612488,      // ₹6.76 crore
      "day-1": 93906,           // ₹93.9k
      "day-3": 281718,          // ₹2.81 lakh
      "day-7": 657343,          // ₹6.57 lakh
      "day-15": 1408593,        // ₹14.08 lakh
      "day-30": 2817187         // ₹28.17 lakh
    },
    paymentSchedule: [
      { date: "2025-03-15", principal: 2361111, interest: 1003906 },
      { date: "2025-04-15", principal: 2361111, interest: 973047 },
      { date: "2025-05-15", principal: 2361111, interest: 942188 },
      { date: "2025-06-15", principal: 2361111, interest: 911328 }
    ],
    prepaymentFeeStructure: "3% of outstanding principal",
    prepaymentMinimumNotice: "15 days",
    prepaymentMinimumAmount: 2000000,
    prepaymentLockInPeriod: "9 months",
    interestRateSensitivity: "high",
    liquidityRisk: "medium",
    creditRisk: "medium",
    counterparty: {
      name: "Various Retail Customers",
      type: "Individual"
    }
  },
  {
    id: "la012",
    name: "PL-004",
    reference: "LA-PERS-2024-032",
    type: "Loan Asset",
    subtype: "Personal Loans",
    principalAmount: 140000000,  // ₹14 crore
    currentBalance: 140000000,   // ₹14 crore
    interestRate: 14.5,          // 14.5% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-02-10",
    firstPaymentDate: "2024-03-10",
    maturityDate: "2027-02-10",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 4229166,        // ₹42.29 lakh
      "month-3": 12687498,       // ₹1.26 crore
      "month-6": 25374996,       // ₹2.53 crore
      "month-12": 50749992,      // ₹5.07 crore
      "month-24": 101499984,     // ₹10.14 crore
      "day-1": 140972,          // ₹1.40 lakh
      "day-3": 422916,          // ₹4.22 lakh
      "day-7": 987138,          // ₹9.87 lakh
      "day-15": 2114583,        // ₹21.14 lakh
      "day-30": 4229166         // ₹42.29 lakh
    },
    paymentSchedule: [
      { date: "2025-03-10", principal: 3888888, interest: 1691666 },
      { date: "2025-04-10", principal: 3888888, interest: 1644444 },
      { date: "2025-05-10", principal: 3888888, interest: 1597222 },
      { date: "2025-06-10", principal: 3888888, interest: 1550000 }
    ],
    prepaymentFeeStructure: "2% of outstanding principal",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 5000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "medium",
    liquidityRisk: "low",
    creditRisk: "medium",
    counterparty: {
      name: "Small Business Entrepreneurs",
      type: "Individual"
    }
  },
  {
    id: "la013",
    name: "PL-005",
    reference: "LA-PERS-2024-057",
    type: "Loan Asset",
    subtype: "Personal Loans",
    principalAmount: 200000000,  // ₹20 crore
    currentBalance: 195000000,   // ₹19.5 crore
    interestRate: 12.75,         // 12.75% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-03-25",
    firstPaymentDate: "2024-04-25",
    maturityDate: "2028-03-25",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 4859375,        // ₹48.59 lakh
      "month-3": 14578125,       // ₹1.45 crore
      "month-6": 29156250,       // ₹2.91 crore
      "month-12": 58312500,      // ₹5.83 crore
      "month-24": 116625000,     // ₹11.66 crore
      "day-1": 161979,          // ₹1.61 lakh
      "day-3": 485937,          // ₹4.85 lakh
      "day-7": 1133854,         // ₹11.33 lakh
      "day-15": 2429687,        // ₹24.29 lakh
      "day-30": 4859375         // ₹48.59 lakh
    },
    paymentSchedule: [
      { date: "2025-03-25", principal: 4166666, interest: 2071875 },
      { date: "2025-04-25", principal: 4166666, interest: 2027343 },
      { date: "2025-05-25", principal: 4166666, interest: 1982812 },
      { date: "2025-06-25", principal: 4166666, interest: 1938281 }
    ],
    prepaymentFeeStructure: "1.5% of outstanding principal",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 10000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "medium",
    liquidityRisk: "low",
    creditRisk: "low",
    counterparty: {
      name: "Professional Services Group",
      type: "Corporate",
      rating: "A"
    }
  },
  
  // SME Loans
  {
    id: "la002",
    name: "SME-001",
    reference: "LA-CORP-2024-007",
    type: "Loan Asset",
    subtype: "SME Loans",
    principalAmount: 180000000,  // ₹18 crore
    currentBalance: 180000000,   // ₹18 crore
    interestRate: 13.75,         // 13.75% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-01-05",
    firstPaymentDate: "2024-04-05",
    maturityDate: "2027-01-05",
    repaymentFrequency: "Quarterly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 2045000,       // ₹20.45 lakh
      "month-3": 16275000,       // ₹1.62 crore
      "month-6": 32550000,       // ₹3.25 crore
      "month-12": 65100000,      // ₹6.51 crore
      "month-24": 130200000,     // ₹13.02 crore
      "day-1": 681666,         // ₹6.81 lakh
      "day-3": 2045000,        // ₹20.45 lakh
      "day-7": 4771666,        // ₹47.71 lakh
      "day-15": 8181250,       // ₹81.81 lakh
      "day-30": 16362500       // ₹1.63 crore
    },
    paymentSchedule: [
      { date: "2025-04-05", principal: 15000000, interest: 6187500 },
      { date: "2025-07-05", principal: 15000000, interest: 5671875 },
      { date: "2025-10-05", principal: 15000000, interest: 5156250 },
      { date: "2026-01-05", principal: 15000000, interest: 4640625 }
    ],
    prepaymentFeeStructure: "2.5% of prepaid amount",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 30000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "low",
    liquidityRisk: "medium",
    creditRisk: "medium",
    counterparty: {
      name: "Sriram Textiles Ltd",
      type: "Corporate",
      rating: "A+"
    }
  },
  {
    id: "la003",
    name: "SME-002",
    reference: "LA-MSME-2024-012",
    type: "Loan Asset",
    subtype: "SME Loans",
    principalAmount: 75000000,   // ₹7.5 crore
    currentBalance: 72000000,    // ₹7.2 crore
    interestRate: 14.5,          // 14.5% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-02-10",
    firstPaymentDate: "2024-03-10",
    maturityDate: "2027-02-10",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 2175000,        // ₹21.75 lakh
      "month-3": 6525000,        // ₹65.25 lakh
      "month-6": 13050000,       // ₹1.30 crore
      "month-12": 26100000,      // ₹2.61 crore
      "month-24": 52200000,      // ₹5.22 crore
      "day-1": 72500,           // ₹72.5k
      "day-3": 217500,          // ₹2.17 lakh
      "day-7": 507500,          // ₹5.07 lakh
      "day-15": 1087500,        // ₹10.87 lakh
      "day-30": 2175000         // ₹21.75 lakh
    },
    paymentSchedule: [
      { date: "2025-03-10", principal: 1875000, interest: 870000 },
      { date: "2025-04-10", principal: 1875000, interest: 847500 },
      { date: "2025-05-10", principal: 1875000, interest: 825000 },
      { date: "2025-06-10", principal: 1875000, interest: 802500 }
    ],
    prepaymentFeeStructure: "3% of outstanding principal",
    prepaymentMinimumNotice: "15 days",
    prepaymentMinimumAmount: 5000000,
    prepaymentLockInPeriod: "6 months",
    interestRateSensitivity: "medium",
    liquidityRisk: "medium",
    creditRisk: "medium",
    counterparty: {
      name: "Naveen Industries",
      type: "MSME",
      rating: "BBB"
    }
  },
  {
    id: "la014",
    name: "SME-003",
    reference: "LA-MSME-2023-078",
    type: "Loan Asset",
    subtype: "SME Loans",
    principalAmount: 125000000,  // ₹12.5 crore
    currentBalance: 110000000,   // ₹11 crore
    interestRate: 13.75,         // 13.75% p.a.
    interestType: "Fixed",
    sanctionDate: "2023-06-15",
    firstPaymentDate: "2023-07-15",
    maturityDate: "2026-06-15",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 3032812,        // ₹30.32 lakh
      "month-3": 9098436,        // ₹90.98 lakh
      "month-6": 18196872,       // ₹1.81 crore
      "month-12": 36393744,      // ₹3.63 crore
      "month-24": 72787488,      // ₹7.27 crore
      "day-1": 101094,          // ₹1.01 lakh
      "day-3": 303282,          // ₹3.03 lakh
      "day-7": 707656,          // ₹7.07 lakh
      "day-15": 1516406,        // ₹15.16 lakh
      "day-30": 3032812         // ₹30.32 lakh
    },
    paymentSchedule: [
      { date: "2025-03-15", principal: 3472222, interest: 1260416 },
      { date: "2025-04-15", principal: 3472222, interest: 1220703 },
      { date: "2025-05-15", principal: 3472222, interest: 1180989 },
      { date: "2025-06-15", principal: 3472222, interest: 1141276 }
    ],
    prepaymentFeeStructure: "2% of outstanding principal",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 10000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "medium",
    liquidityRisk: "medium",
    creditRisk: "medium",
    counterparty: {
      name: "Techno Solutions Ltd",
      type: "Corporate",
      rating: "BBB+"
    }
  },
  {
    id: "la015",
    name: "SME-004",
    reference: "LA-MSME-2024-034",
    type: "Loan Asset",
    subtype: "SME Loans",
    principalAmount: 90000000,   // ₹9 crore
    currentBalance: 90000000,    // ₹9 crore
    interestRate: 14.25,         // 14.25% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-02-20",
    firstPaymentDate: "2024-03-20",
    maturityDate: "2027-02-20",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 2656250,        // ₹26.56 lakh
      "month-3": 7968750,        // ₹79.68 lakh
      "month-6": 15937500,       // ₹1.59 crore
      "month-12": 31875000,      // ₹3.18 crore
      "month-24": 63750000,      // ₹6.37 crore
      "day-1": 88542,           // ₹88.5k
      "day-3": 265625,          // ₹2.65 lakh
      "day-7": 619792,          // ₹6.19 lakh
      "day-15": 1328125,        // ₹13.28 lakh
      "day-30": 2656250         // ₹26.56 lakh
    },
    paymentSchedule: [
      { date: "2025-03-20", principal: 2500000, interest: 1068750 },
      { date: "2025-04-20", principal: 2500000, interest: 1039062 },
      { date: "2025-05-20", principal: 2500000, interest: 1009375 },
      { date: "2025-06-20", principal: 2500000, interest: 979687 }
    ],
    prepaymentFeeStructure: "2.5% of outstanding principal",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 5000000,
    prepaymentLockInPeriod: "9 months",
    interestRateSensitivity: "medium",
    liquidityRisk: "medium",
    creditRisk: "medium",
    counterparty: {
      name: "Food Processing Ltd",
      type: "Corporate",
      rating: "BBB"
    }
  },
  {
    id: "la016",
    name: "SME-005",
    reference: "LA-MSME-2024-058",
    type: "Loan Asset",
    subtype: "SME Loans",
    principalAmount: 150000000,  // ₹15 crore
    currentBalance: 150000000,   // ₹15 crore
    interestRate: 13.5,          // 13.5% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-03-15",
    firstPaymentDate: "2024-04-15",
    maturityDate: "2028-03-15",
    repaymentFrequency: "Monthly",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 4218750,        // ₹42.18 lakh
      "month-3": 12656250,       // ₹1.26 crore
      "month-6": 25312500,       // ₹2.53 crore
      "month-12": 50625000,      // ₹5.06 crore
      "month-24": 101250000,     // ₹10.12 crore
      "day-1": 140625,          // ₹1.40 lakh
      "day-3": 421875,          // ₹4.21 lakh
      "day-7": 984375,          // ₹9.84 lakh
      "day-15": 2109375,        // ₹21.09 lakh
      "day-30": 4218750         // ₹42.18 lakh
    },
    paymentSchedule: [
      { date: "2025-03-15", principal: 3125000, interest: 1687500 },
      { date: "2025-04-15", principal: 3125000, interest: 1652343 },
      { date: "2025-05-15", principal: 3125000, interest: 1617187 },
      { date: "2025-06-15", principal: 3125000, interest: 1582031 }
    ],
    prepaymentFeeStructure: "2% of outstanding principal",
    prepaymentMinimumNotice: "45 days",
    prepaymentMinimumAmount: 15000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "medium",
    liquidityRisk: "medium",
    creditRisk: "low",
    counterparty: {
      name: "Precision Engineering Works",
      type: "Corporate",
      rating: "A-"
    }
  },
  
  // Gold Loans
  {
    id: "la007",
    name: "GL-001",
    reference: "LA-CF-2024-005",
    type: "Loan Asset",
    subtype: "Gold Loans",
    principalAmount: 350000000,  // ₹35 crore
    currentBalance: 350000000,   // ₹35 crore
    interestRate: 15.5,          // 15.5% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-01-25",
    firstPaymentDate: "2026-01-25",
    maturityDate: "2027-01-25",
    repaymentFrequency: "Bullet",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 4520833,        // ₹45.2 lakh (interest only)
      "month-3": 13562500,       // ₹1.35 crore (interest only)
      "month-6": 27125000,       // ₹2.71 crore (interest only)
      "month-12": 54250000,      // ₹5.42 crore (interest only)
      "month-24": 454250000,     // ₹45.42 crore (principal + final interest)
      "day-1": 150694,          // ₹1.5 lakh
      "day-3": 452083,          // ₹4.52 lakh
      "day-7": 1054861,         // ₹10.54 lakh
      "day-15": 2260417,        // ₹22.6 lakh
      "day-30": 4520833         // ₹45.2 lakh
    },
    prepaymentFeeStructure: "3% of prepaid amount",
    prepaymentMinimumNotice: "60 days",
    prepaymentMinimumAmount: 100000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "low",
    liquidityRisk: "high",
    creditRisk: "medium",
    counterparty: {
      name: "Metro Heights Developers",
      type: "Corporate",
      rating: "BBB+"
    }
  },
  {
    id: "la017",
    name: "GL-002",
    reference: "LA-GOLD-2023-042",
    type: "Loan Asset",
    subtype: "Gold Loans",
    principalAmount: 120000000,  // ₹12 crore
    currentBalance: 120000000,   // ₹12 crore
    interestRate: 14.75,         // 14.75% p.a.
    interestType: "Fixed",
    sanctionDate: "2023-05-10",
    firstPaymentDate: "2025-05-10",
    maturityDate: "2025-05-10",
    repaymentFrequency: "Bullet",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 1475000,        // ₹14.75 lakh (interest only)
      "month-3": 4425000,        // ₹44.25 lakh (interest only)
      "month-6": 8850000,        // ₹88.5 lakh (interest only)
      "month-12": 17700000,      // ₹1.77 crore (interest only)
      "month-24": 137700000,     // ₹13.77 crore (principal + final interest)
      "day-1": 49167,           // ₹49.16k
      "day-3": 147500,          // ₹1.47 lakh
      "day-7": 344167,          // ₹3.44 lakh
      "day-15": 737500,         // ₹7.37 lakh
      "day-30": 1475000         // ₹14.75 lakh
    },
    prepaymentFeeStructure: "2.5% of prepaid amount",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 20000000,
    prepaymentLockInPeriod: "6 months",
    interestRateSensitivity: "low",
    liquidityRisk: "medium",
    creditRisk: "low",
    counterparty: {
      name: "Jewellers Association",
      type: "Corporate",
      rating: "A-"
    }
  },
  {
    id: "la018",
    name: "GL-003",
    reference: "LA-GOLD-2024-012",
    type: "Loan Asset",
    subtype: "Gold Loans",
    principalAmount: 200000000,  // ₹20 crore
    currentBalance: 200000000,   // ₹20 crore
    interestRate: 15.25,         // 15.25% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-01-15",
    firstPaymentDate: "2025-01-15",
    maturityDate: "2025-07-15",
    repaymentFrequency: "Bullet",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 2541667,        // ₹25.41 lakh (interest only)
      "month-3": 7625000,        // ₹76.25 lakh (interest only)
      "month-6": 15250000,       // ₹1.52 crore (interest only)
      "month-12": 30500000,      // ₹3.05 crore (interest only)
      "month-24": 215250000,     // ₹21.52 crore (principal + final interest)
      "day-1": 84722,           // ₹84.7k
      "day-3": 254167,          // ₹2.54 lakh
      "day-7": 593056,          // ₹5.93 lakh
      "day-15": 1270834,        // ₹12.70 lakh
      "day-30": 2541667         // ₹25.41 lakh
    },
    prepaymentFeeStructure: "2% of prepaid amount",
    prepaymentMinimumNotice: "45 days",
    prepaymentMinimumAmount: 50000000,
    prepaymentLockInPeriod: "3 months",
    interestRateSensitivity: "low",
    liquidityRisk: "medium",
    creditRisk: "low",
    counterparty: {
      name: "Gold Star Merchants Ltd",
      type: "Corporate",
      rating: "A"
    }
  },
  {
    id: "la019",
    name: "GL-004",
    reference: "LA-GOLD-2024-028",
    type: "Loan Asset",
    subtype: "Gold Loans",
    principalAmount: 160000000,  // ₹16 crore
    currentBalance: 160000000,   // ₹16 crore
    interestRate: 15.75,         // 15.75% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-02-20",
    firstPaymentDate: "2025-02-20",
    maturityDate: "2026-02-20",
    repaymentFrequency: "Bullet",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 2100000,        // ₹21 lakh (interest only)
      "month-3": 6300000,        // ₹63 lakh (interest only)
      "month-6": 12600000,       // ₹1.26 crore (interest only)
      "month-12": 25200000,      // ₹2.52 crore (interest only)
      "month-24": 185200000,     // ₹18.52 crore (principal + final interest)
      "day-1": 70000,           // ₹70k
      "day-3": 210000,          // ₹2.1 lakh
      "day-7": 490000,          // ₹4.9 lakh
      "day-15": 1050000,        // ₹10.5 lakh
      "day-30": 2100000         // ₹21 lakh
    },
    prepaymentFeeStructure: "3% of prepaid amount",
    prepaymentMinimumNotice: "30 days",
    prepaymentMinimumAmount: 30000000,
    prepaymentLockInPeriod: "9 months",
    interestRateSensitivity: "low",
    liquidityRisk: "medium",
    creditRisk: "medium",
    counterparty: {
      name: "Precious Metals Trading Co",
      type: "Corporate",
      rating: "BBB+"
    }
  },
  {
    id: "la020",
    name: "GL-005",
    reference: "LA-GOLD-2024-037",
    type: "Loan Asset",
    subtype: "Gold Loans",
    principalAmount: 250000000,  // ₹25 crore
    currentBalance: 250000000,   // ₹25 crore
    interestRate: 16.0,          // 16.0% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-03-10",
    firstPaymentDate: "2026-03-10",
    maturityDate: "2027-03-10",
    repaymentFrequency: "Bullet",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 3333333,        // ₹33.33 lakh (interest only)
      "month-3": 10000000,       // ₹1 crore (interest only)
      "month-6": 20000000,       // ₹2 crore (interest only)
      "month-12": 40000000,      // ₹4 crore (interest only)
      "month-24": 290000000,     // ₹29 crore (principal + final interest)
      "day-1": 111111,          // ₹1.11 lakh
      "day-3": 333333,          // ₹3.33 lakh
      "day-7": 777778,          // ₹7.77 lakh
      "day-15": 1666667,        // ₹16.66 lakh
      "day-30": 3333333         // ₹33.33 lakh
    },
    prepaymentFeeStructure: "3.5% of prepaid amount",
    prepaymentMinimumNotice: "60 days",
    prepaymentMinimumAmount: 75000000,
    prepaymentLockInPeriod: "12 months",
    interestRateSensitivity: "low",
    liquidityRisk: "high",
    creditRisk: "medium",
    counterparty: {
      name: "Luxury Jewels Pvt Ltd",
      type: "Corporate",
      rating: "A-"
    }
  },
  
  // Fixed Deposits
  {
    id: "fd001",
    name: "SBI Fixed Deposit",
    reference: "FD-SBI-2024-005",
    type: "Fixed Deposit",
    principalAmount: 100000000,  // ₹10 crore
    currentBalance: 100000000,   // ₹10 crore
    interestRate: 7.25,          // 7.25% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-01-10",
    firstPaymentDate: "2024-07-10",
    maturityDate: "2025-01-10",
    repaymentFrequency: "At Maturity",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 0,
      "month-3": 0,
      "month-6": 3625000,        // ₹36.25 lakh
      "month-12": 107250000,     // ₹10.72 crore
      "month-24": 0,
      "day-1": 0,
      "day-3": 0,
      "day-7": 0,
      "day-15": 0,
      "day-30": 0
    },
    paymentSchedule: [
      { date: "2024-07-10", principal: 0, interest: 3625000 },
      { date: "2025-01-10", principal: 100000000, interest: 3625000 }
    ],
    prepaymentFeeStructure: "1% penalty on interest",
    prepaymentMinimumNotice: "7 days",
    interestRateSensitivity: "medium",
    liquidityRisk: "medium",
    creditRisk: "low",
    counterparty: {
      name: "State Bank of India",
      type: "Bank",
      rating: "AAA"
    }
  },
  {
    id: "fd002",
    name: "ICICI Bank Fixed Deposit",
    reference: "FD-ICICI-2024-012",
    type: "Fixed Deposit",
    principalAmount: 75000000,   // ₹7.5 crore
    currentBalance: 75000000,    // ₹7.5 crore
    interestRate: 7.1,           // 7.1% p.a.
    interestType: "Fixed",
    sanctionDate: "2024-02-20",
    firstPaymentDate: "2025-02-20",
    maturityDate: "2025-02-20",
    repaymentFrequency: "At Maturity",
    prepaymentOption: true,
    penalties: true,
    cashflows: {
      "month-1": 0,
      "month-3": 0,
      "month-6": 0,
      "month-12": 80325000,     // ₹8.03 crore
      "month-24": 0,
      "day-1": 0,
      "day-3": 0,
      "day-7": 0,
      "day-15": 0,
      "day-30": 0
    },
    paymentSchedule: [
      { date: "2025-02-20", principal: 75000000, interest: 5325000 }
    ],
    prepaymentFeeStructure: "1.5% penalty on interest",
    prepaymentMinimumNotice: "10 days",
    interestRateSensitivity: "medium",
    liquidityRisk: "medium",
    creditRisk: "low",
    counterparty: {
      name: "ICICI Bank",
      type: "Bank",
      rating: "AAA"
    }
  }
];
